/* eslint-disable */
import embLabels from "../../../config/emb-labels-en.json";
import ACTIONS from "../Design_Asset_Actions.json";
import { coOrdinateValidator } from "../../../utils/coOrdinateValidator";
const useAssetSwitchboardHandler = (deps) => {
  const {
    projectTypeValue, dispatch, UserScope, projectType,
    loading, setLoading,
    displayPage, setDisplayPage,
    sldLoadCompleted, setSldLoadCompleted,
    useCaseValidGenset, setUseCaseValidGenset,
    deleteOneDER, setDeleteOneDER,
    defaultConfigurationStatus, setDefaultConfigurationStatus,
    siteCreated, setSiteCreated,
    isOpen, setIsOpen,
    siteType, setSiteType,
    evceDiagramChangeRequired, setEvceDiagramChangeRequired,
    isAllowMultipleLoads, setIsAllowMultipleLoads,
    isExportOptimization, setIsExportOptimization,
    switchboardType, setSwitchboardType,
    clientType, setClientType,
    architectureType, setArchitectureType,
    nominalVoltage, setNominalVoltage,
    isSelectSpanishCode, setIsSelectSpanishCode,
    defaultPreFillData, setDefaultPreFillData,
    availableDer, setAvailableDer,
    useCases, setUseCases,
    isEvce, setIsEvce,
    prevPvGroupNames, setPrevPvGroupNames,
    batteryCommunicationData, setBatteryCommunicationData,
    evCommunicationData, setEvCommunicationData,
    powerMeter, setPowerMeter,
    communicationState, setCommunicationState,
    cbCommunicationValues, setCbCommunicationValues,
    detailsBlock, setDetailsBlock,
    selectedValues, setSelectedValues,
    configData, setConfigData,
    isLoadNameUnique, setIsLoadNameUnique,
    gsxExternalId, setGsxExternalId,
    isBessController, setIsBessController,
    assetDetailsDisplay, setAssetDetailsDisplay,
    assetInfo, setAssetInfo,
    bessControllerPrevValue, setBessControllerPrevValue,
    cbDer, setCbder,
    CBValues, setCBValues,
    defaultsMinMax, setDefaultsMinMax,
    coordinates, setCoordinates,
    rectangleWidth, setRectangleWidth,
    snackBar, setSnackBar,
    alert, setAlert,
    confirm, setConfirm,
    remoteConfirm, setRemoteConfirm,
    duplicateUpdate, setDuplicateUpdate,
    runCalculateCoordinates, setRunCalculateCoordinates,
    runGenerateComponentsBlock, setRunGenerateComponentsBlock,
    batteryRack, setBatteryRack,
    batterySystemA2EConfig, setBatterySystemA2EConfig,
    isOpenLoadConfig, setIsOpenLoadConfig,
    isOpenGtConfig, setIsOpenGtConfig,
    loadSide, setLoadSide,
    isAntiIslandingRelayEnable, setIsAntiIslandingRelayEnable,
    gridTransitionOnline, setGridTransitionOnline,
    defaultCbData, setDefaultCbData,
    defaultPmData, setDefaultPmData,
    defaultDummyCbData, setDefaultDummyCbData,
    gensetAssetData, setGensetAssetData,
    evContactorData, setEVContactorData,
    gTContractorData, setGTContractorData,
    defaultGTData, setGTDefaultData,
    evDefaultData, setEVDefaultData,
    evPMData, setEVPMData,
    jsonData, setJsonData,
    isContactorEnabled, setIsContactorEnabled,
    cbLoadData, setCBLoadData,
    currentProject, setCurrentProject,
    defaultComponentData, setDefaultComponentData,
    updateComponents, setUpdateComponents,
    cbCount, setCbCount,
    spanishCodeRealTime, setSpanishCodeRealTime,
    assetDefaultValues, setAssetDefaultValues,
    isAssetConfigChanged, setIsAssetConfigChanged,
    gtTempConfigData, setGtTempConfigData,
    projectStatusData,
    deploymentReady, setDeploymentReady,
    ComponentData, ComponentDataDispatch,
    CBAssetList, CBAssetListDispatch,
    CBEVList, CBEVListDispatch,
    CBLoadList, CBLoadListDispatch,
    CBGTList, CBGTListDispatch,
    firstTimeCall, setFirstTimecall,
    multipleLoads, setMultipleLoads,
    count, countDispatch,
    projectKind, projectKindDispatch,
    PVDetails, PVDetailsDispatch,
    selectedLoadIndx, setSelectedLoadIndx,
    projectId,
    initialRenderCoordinates,
    initialRenderPvConfigured,
    snackBarRef,
    isUpdatingComponent,
    remoteMain, setRemoteMain,
    considerSelected, setConsiderSelected,
    assetDetails, setAssetDetails,
    // projectKind flags
    isMgaasAnsi, isDaasAnsi, isDaasEto, isMgaasIec, isDaasIec,
    isMgaasAnsiGrid, isDaasAnsiGrid, isDaasEtoGrid,
    isMgaasAnsiIsland, isDaasAnsiIsland, isDaasEtoIsland,
    isMgaasIecGrid, isDaasIecGrid, isMgaasIecIsland,
    isGridConnected, isGridConnectedGSX, isIslandable, isIslandableGSX,
    isA2E, isLineSide, isExistingSwitchBoard, isLoadSide, isNewSwitchBoard,
    isGreenStruxure, isGeneric, isGreenStruxureMicrogrid,
    isPVGensetATS, isFuelSaver, isPVBessNR, isPVHybrid, isPVGensetA2E,
    isGensetMainNoBess, isNoFuel, isETO,
    isMGaaSETOGrid, isMGaaSETOIsland, isMGaaSETO, isMGaaSETOGensetPvHybrid,
    isNMGaaSETOGrid, isNMGaaSETOIsland, isNMGaaSETO, isNMGaaSETOGensetPvHybrid,
    isMgaasAnsiOffGrid, isMgaasIecOffGrid, isMassEtoOffGrid,
    // cross-hook ref
    fnRef,
    allowedCbCount
  } = deps;

  // Cross-hook function aliases
  const callSnackbar = (...args) => fnRef.current.callSnackbar(...args);
  const generateComponentsBlock = (...args) => fnRef.current.generateComponentsBlock(...args);
  const calculateCoOridinates = (...args) => fnRef.current.calculateCoOridinates(...args);
  const checkAssetStatus = (...args) => fnRef.current.checkAssetStatus(...args);
  const addPv = (...args) => fnRef.current.addPv(...args);
  const addBattery = (...args) => fnRef.current.addBattery(...args);
  const setAlertMessage = (...args) => fnRef.current.setAlertMessage(...args);
  const checkSLDCount = (...args) => fnRef.current.checkSLDCount(...args);
  const assetDetailsReset = (...args) => fnRef.current.assetDetailsReset(...args);

  const handleSwitchboardTypeChangeGSX = (switchType) => {
    setSwitchboardType(switchType);
    let x21, x22, x11, y11, y21, x12, y12, y22;
    if(switchType===embLabels.NEW_SWITCHBOARD){
      const removeRemoteLoad = [];
      const loadData = [...CBLoadList]
      loadData.forEach((load,index)=>{
        if(load.uiData.isRemoteLoad){
          removeRemoteLoad.push(index)
           countDispatch({
            type:  ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
            payload: {count: -1}
          });
        }
      })
      if(removeRemoteLoad?.length>0){
        CBLoadListDispatch({
          type:  ACTIONS.REMOVE_REMOTE_LOAD,
          payload: {
            indexes: removeRemoteLoad
          }
        });
        
      }
    }
    assetDetailsReset();
    if (
      siteType === embLabels.ISLANDABLE &&
      projectTypeValue !== "MGaaS ANSI"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count, siteType:siteType, projectKind: projectKind, switchboardType },
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count },
      });
    }

    if (siteType === embLabels.GRID_CONNECTED && clientType === "GENERIC") {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GRIDCONNECTED,
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });
    }
    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      (siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide:loadSide,
        }
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });
    }
    let coOrdinates = {
      x11,
      y11,
      x21,
      y21,
      x12,
      y12,
      x22,
      y22,
    };

    // --------------------

    if (
      siteType === embLabels.ISLANDABLE &&
      projectTypeValue !== "MGaaS ANSI"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count, siteType:siteType, projectKind: projectKind ,switchboardType },
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count },
      });
    }
    if (siteType === embLabels.PV_HYBRIDIZATION) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVHYBRIDIZATION,
        payload: { coordinates: coordinates,switchType:switchType },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVHYBRIDIZATION,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "426",
          y11: "360",
          x21: "815",
          y21: "360",
        },
      }));

      checkAssetStatus();
    }

    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      clientType === embLabels.GREENSTRUXURE_PROJECT &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1].mode !== "FUEL_SAVER"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS,
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS_OP,
        payload: "switchType",
      });

      checkAssetStatus();
    }

    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      (siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide:loadSide,
        }
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });

      checkAssetStatus();
    }

    if (
      (siteType === embLabels.GRID_CONNECTED_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_BESS_NR) ||
      (siteType === embLabels.GRID_CONNECTED &&
        projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType: switchboardType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind,
        }
      });

      checkAssetStatus();
    }

    if (
      siteType === embLabels.GENSET_PVBESS_A2E &&
      clientType === embLabels.A2E_PROJECT
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GENSET_PVBESS_A2E,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVHYBRIDIZATION,
      });
      // setCoordinates((prevCoordinates) => ({
      //   ...prevCoordinates,
      //   busbarCordinates: {
      //     ...prevCoordinates.busbarCordinates,
      //     x11: "426",
      //     y11: "360",
      //     x21: "815",
      //     y21: "360",
      //   },
      // })
      // );

      checkAssetStatus();
    }

    // ---------------

    if (projectTypeValue === "DaaS IEC") {
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVBESS_NR,
        payload: switchType,
      });
    }
    if(isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland){
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_ISLANDABLE,
        payload: {
          switchType: switchboardType,
          mode: defaultPreFillData[1]?.mode,
          projectKind: projectKind,
        },
      });
    }
    const coOrdinateLists = coOrdinateValidator(
      coOrdinates,
      switchType,
      siteType,
      projectTypeValue,
      count,
      rectangleWidth,
      loadSide,
      clientType,
      defaultPreFillData[1]?.mode,
      projectKind,
    );
    setRectangleWidth(coOrdinateLists.rectangleWidth);
    setCoordinates((prevCoordinates) => ({
      ...prevCoordinates,
      busbarCordinates: {
        ...prevCoordinates.busbarCordinates,
        ...coOrdinateLists.cooridinates,
      },
    }));
    if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
     ( projectTypeValue === "DaaS ANSI" ||  projectTypeValue === "DaaS ETO")
    ) {
      setLoadSide(coOrdinateLists.loadSide);
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,  
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
    }
    if (
      siteType === embLabels.GRID_CONNECTED &&
      projectTypeValue === "MGaaS ANSI"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS_OP,
        payload: "switchType",
      });
    }

    if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      projectTypeValue === "DaaS IEC"
    ) {
      setRectangleWidth(coOrdinateLists.rectangleWidth);
      setLoadSide(coOrdinateLists.loadSide);
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
    }

    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      projectTypeValue === "DaaS IEC"
    ) {
      setRectangleWidth(coOrdinateLists.rectangleWidth);
      setLoadSide(coOrdinateLists.loadSide);
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType:"",
          mode: "",
          loadSide:loadSide,
        }
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });
    }

    //000000000000000000000000

    setSwitchboardType(switchType);
    if (siteType === embLabels.GRID_CONNECTED && clientType === "GENERIC") {
      let x21 =
        count.derCount === 2
          ? "695"
          : count.derCount === 3
          ? "910"
          : count.derCount === 4
          ? "1015"
          : count.derCount === 5
          ? switchType === embLabels.EXISTING_SWITCHBOARD
            ? "1145"
            : "1045"
          : "795";

      if (switchType === "EXISTING_SWITCHBOARD") {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "480",
          xDerCBDiff: "700",
          yDerGrid: "243",
          yDerCBDiff: "370",
          xDerGridPM: "605",
          yDerGridPM: "227.5",
          cbEV: {
            xDerEV: 597.5,
            yDerEV: 492,
            xDerPM: 545,
            yDerPM: 487.5,
            x1DerEVCB: 675,
            y1DerEVCB: 570,
            x2DerEVCB: 675,
            y2DerEVCB: 464,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "126",
            y11: "280",
            x21: "345",
            y21: "280",
            x12: "620",
            y12: "470",
            x22: x21,
            y22: "470",
          },
        }));
      } else {
        let x21 =
          count.derCount === 2
            ? "695"
            : count.derCount === 3
            ? "810"
            : count.derCount === 4
            ? "915"
            : count.derCount === 5
            ? "1045"
            : "795";

        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "370",
          xDerCBDiff: "590",
          yDerGrid: "141",
          yDerCBDiff: "269",
          xDerGridPM: "495",
          yDerGridPM: "127.5",
          cbEV: {
            xDerEV: 477.5,
            yDerEV: 553,
            xDerPM: 425,
            yDerPM: 617.5,
            x1DerEVCB: 555,
            y1DerEVCB: 463,
            x2DerEVCB: 555,
            y2DerEVCB: 367,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "426",
            y11: "370",
            x21: x21,
            y21: "370",
            x12: "700",
            y12: "470",
            x22: "900",
            y22: "470",
          },
        }));
      }

      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GRIDCONNECTED,
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });
    }
    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      (siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide:loadSide,
        }
      });
      // CBLoadListDispatch({
      //   type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS,
      // });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });

      let x22;
      if (count.derCount <= 3 && count.loadCount <= 4) {
        x22 = "1095";
      } else if (count.derCount <= 4 && count.loadCount <= 4) {
        siteType === "GRID_CONNECTED_GSX" ||
        (siteType === "ISLANDABLE_GSX" &&
          (switchType === "" || switchType === embLabels.EXISTING_SWITCHBOARD))
          ? (x22 = "1095")
          : (x22 = "510");
      } else if (count.derCount <= 4 && count.loadCount === 5) {
        switchType === embLabels.NEW_SWITCHBOARD &&
        siteType === "ISLANDABLE_GSX"
          ? (x22 = 570)
          : (x22 = "1170");
      } else if (count.loadCount === 10) {
        switchType === embLabels.NEW_SWITCHBOARD &&
        siteType === "ISLANDABLE_GSX"
          ? (x22 = 650)
          : (x22 = "1250");
      } else {
        {
          siteType === "ISLANDABLE_GSX" &&
          switchType === embLabels.NEW_SWITCHBOARD
            ? (x22 = "620")
            : (x22 = "1170");
        }
      }

      // x21: "594",

      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "158",
          y11: "285",
          x21: "330",
          y21: "285",
          x12: "630",
          y12: "430",
          x22: x22,
          y22: "430",
        },
      }));
    }

    if (
      (siteType === embLabels.GRID_CONNECTED_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_BESS_NR) ||
      (projectTypeValue === "MGaaS ANSI" &&
        siteType === embLabels.GRID_CONNECTED)
    ) {
      const x21 = count.derCount === 2 ? "815" : "715";
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVBESS_NR,
        payload: switchType,
      });
      let x22;
      if (count.derCount > 3) {
        setRectangleWidth(530);
        if (
          ["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) &&
          (switchType === "" || switchType === embLabels.EXISTING_SWITCHBOARD)
        ) {
          x22 = 1065;
        } else {
          siteType === "ISLANDABLE_GSX" &&
          switchType === embLabels.NEW_SWITCHBOARD
            ? (x22 = 690)
            : (x22 = 640);
          setRectangleWidth(730);
        }
      } else {
        if (
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
          (siteType !== "ISLANDABLE_GSX" &&
            (switchType === "" ||
              switchType === embLabels.EXISTING_SWITCHBOARD))
        ) {
          setRectangleWidth(420);
          x22 = 965;
        } else {
          setRectangleWidth(580);
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
          (siteType !== "ISLANDABLE_GSX" &&
            (switchType !== "" ||
              switchType !== embLabels.EXISTING_SWITCHBOARD))
            ? (x22 = 510)
            : (x22 = 965);
        }
      }
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "168",
          y11: "283",
          x21: "408",
          y21: "283",
          x12: "630",
          y12: "430",
          x22,
          y22: "430",
        },
      }));

      checkAssetStatus();
    }
    if(siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI"){
      if(switchboardType === embLabels.EXISTING_SWITCHBOARD){
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 250,
            yDerEV: 290,
            xDerPM: 475,
            yDerPM: 490,
            x1DerEVCB: 608,
            y1DerEVCB: 570,
            x2DerEVCB: 608,
            y2DerEVCB: 470,
          },
                
        }));
      }else{
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 80,
            yDerEV: 320,
            xDerPM: 25,
            yDerPM: 320,
            x1DerEVCB: 377.5,
            y1DerEVCB: 398.5,
            x2DerEVCB: 378.5,
            y2DerEVCB: 300,
          },  
             
        }));
      }
    }
    if(switchboardType===embLabels.EXISTING_SWITCHBOARD&&(isMgaasAnsiIsland||isDaasAnsiIsland ||isDaasEtoIsland)){
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
        payload: { coordinates: coordinates,loadSide:loadSide, count: count ,siteType:siteType, projectKind: projectKind,switchboardType},
      });
    }
    CBEVListDispatch({
      type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
      payload: { coordinates: coordinates, count: count },
    });

    setCoordinates((prevCoordinates) => ({
      ...prevCoordinates,
      busbarCordinates: {
        ...prevCoordinates.busbarCordinates,
        ...coOrdinateLists.cooridinates,
      },
    }));
    setRectangleWidth(coOrdinateLists.rectangleWidth);

    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    const runCalculateCoordinatesNew = { componentPush: false };
    setRunCalculateCoordinates(runCalculateCoordinatesNew);
    sessionStorage.setItem("componentDataModified",true);
  };
 
 
  const handleSetLoadSide = (e) => {
    setLoadSide(e.target.value);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
   if(isMgaasAnsiIsland || isDaasAnsiIsland || isDaasEtoIsland){
    CBAssetListDispatch({
      type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
      payload: {
        switchType: switchboardType,
        mode: defaultPreFillData[1]?.mode,
        clientType: "GENERIC",
        loadSide:e.target.value,
      },
    });
   }
   
   if(isDaasAnsiGrid || isDaasEtoGrid || isMgaasAnsiGrid){
    CBAssetListDispatch({
      type:ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
      payload: {
        switchType: switchboardType,
        mode: defaultPreFillData[1]?.mode,
        clientType: "GENERIC",
        loadSide:e.target.value,
        projectKind:projectKind
      },
    });
   }
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    sessionStorage.setItem("componentDataModified",true);

  };

  const onAddPvExisiting = () => {
    CBAssetListDispatch({
      type: ACTIONS.ADD_PV_EXISTING,
    });
    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const onAddBatteryExisting = () => {
    CBAssetListDispatch({
      type: ACTIONS.ADD_BESS_EXISTIING,
    });
    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const removeExistingPm = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_EXISTING,
      payload: {
        selectedPv: selectedValues?.selectedAssetPM,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      existingPmAssetDetailsBlockGrid: false,
    }));

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };
 const handleEnergyReserve = (index, isChecked) => {
  const dataConfig = { ...configData?.configData };
     if(isChecked){
      dataConfig["SoC_min_optimization"] = 40;
     }else{
        dataConfig["SoC_min_optimization"] = 12;
     }
      setConfigData((prevState) => ({
        ...prevState,
        configData: dataConfig,
      }));
    // assetEditStatusUpdateDER(e, embLabels.BESS, true);
    // setIsAssetConfigChanged(configData);
    CBAssetListDispatch({
      type: ACTIONS.UPDATE_ENERGY_RESERVE,
      payload: {
        index: index,
        value:isChecked
      },
    });
 }
  const handleCbAssetRequired = (index,e ) => {
    if(cbCount?.assetCbCount >= allowedCbCount && e.target.checked){
    callSnackbar("error", "Error in enabling Circuit Breakers due to maximum Circuit Breaker count used");
    return 

    }
    if(cbCount?.assetCbCount <= allowedCbCount){
    let dummyCbData = null;
    if (siteType === embLabels.GRID_CONNECTED) {
      dummyCbData = { ...defaultDummyCbData };
    }

    CBAssetListDispatch({
      type: ACTIONS.CB_ASSET_REQUIRED,
      payload: {
        index: index,
        defaultCbData: defaultCbData,
        defaultValues: defaultPreFillData[0],
        dummyCbData,
      },
    });
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
  }else{
    
    callSnackbar("error", `Max ${allowedCbCount} circuit breakers are allowed`);
  }
  };

  const handleLoadCBAssetRequired = (index,e) => {
    const newLoadData = _.cloneDeep(CBLoadList);
    if(cbCount?.assetCbCount >= allowedCbCount && e.target.checked){
      callSnackbar("error", "Error in enabling Circuit Breakers due to maximum Circuit Breaker count used");
      return 
  
      }
      
      if(cbCount?.assetCbCount <= allowedCbCount){
        if(!e.target.checked){
          setCurrentProject((prevData) => ({
              ...prevData,
              flexName: configData?.cbConfigData?.name,
            }));
            let cbConfigDataNew = { ...configData?.cbConfigData };
             const cbUniqueName = crypto.randomUUID();
            cbConfigDataNew.name =  `${"LOAD_"+ (index + 1) +"_CB_" +cbUniqueName}`;
            setConfigData((prevState) => {
                    CBLoadListDispatch({
                type: ACTIONS.UPDATE_HANDLE_LOAD_CB_CONFIG,
                payload: {
                  selectedLoadCB: index,
                  cbConfigData:cbConfigDataNew,
                },
              });
            return { ...prevState,
              cbConfigData: cbConfigDataNew,
            }
            });
            
        }else{
            let numbersList = [];
            let LoadListLength =0;
            let cbConfigDataNew = { ...configData?.cbConfigData };
            
            const configNameArray = newLoadData.map(
              (loadData) => loadData?.cbConfigData?.name
            );

            configNameArray.forEach((item) => {
              const match = item?.match(/\d+/);
              if (match) {
                const number = parseInt(match[0], 10);
                if (!numbersList.includes(number)) {
                  numbersList.push(number);
                }
              }
            });

            function getNextAvailableLength(currentLength) {
              if (numbersList.includes(currentLength)) {
                return getNextAvailableLength(currentLength + 1);
              }
              return currentLength;
            }

            LoadListLength = getNextAvailableLength(newLoadData.length);

            // Set new name
            cbConfigDataNew.name = currentProject?.flexName ||`CB Load ${LoadListLength}`;

             
             setConfigData((prevState) => {
                  CBLoadListDispatch({
                type: ACTIONS.UPDATE_HANDLE_LOAD_CB_CONFIG,
                payload: {
                  selectedLoadCB: index,
                  cbConfigData:cbConfigDataNew,
                },
              });
              return {...prevState,
              cbConfigData: cbConfigDataNew,}
            });

           
        }
        CBLoadListDispatch({
          type: ACTIONS.LOAD_CB_ASSET_REQUIRED,
          payload:{
            index: index,
            defaultCbData: defaultCbData,
            defaultValues: defaultPreFillData[0],
          }
        });
   setTimeout(()=>{
    setIsAssetConfigChanged(index);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
   },1000)
  }
  
}
    const handleEVCbChange =(e) =>{
      if (e.target.checked && checkSLDCount()) {
        CBEVListDispatch({ type: ACTIONS.EV_ASSET_CB_REQUIRED,
          payload: {
            checked: e.target.checked,
            defaultCbData: defaultCbData,
            defaultValues: defaultPreFillData[0],          }
         });
        setTimeout(() => {
            const runGenerateComponentsBlockNew = { generateComponentsBlock: true };  
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
          }, 100);
      } else {
        if (e.target.checked === false) {
          CBEVListDispatch({ type: ACTIONS.EV_ASSET_REMOVE_CB });
          setTimeout(() => {
            const runGenerateComponentsBlockNew = { generateComponentsBlock: true };  
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
          }, 100);

        } else {
          callSnackbar("error", "Max 24 loads are allowed");
        }

      }
    }

  const handlePmAssetRequired = (index) => {
    CBAssetListDispatch({
      type: ACTIONS.PV_ASSET_PM_REQUIRED,
      payload: {
        index: index,
        defaultPmData: defaultPmData,
        defaultValues: defaultPreFillData[0],
      },
    });
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
  };
  const handleBessController = (index, e) => {
    const configDataNew = { ...configData.configData };
    const checked = e.target.checked;
    if(checked === false){
     setConfigData((prevState) => {
    return {
     ...prevState, configData:{
      ...prevState.configData,
       quantityOfBess:0,
      perUnitMaxPower:0,
      perUnitMaxEnergy:0,
      max_power:bessControllerPrevValue?.max_power,
      capacity:bessControllerPrevValue?.capacity,
     }
    }
   });
   }else{
     setConfigData((prevState) => {
    return {
     ...prevState, configData:{
      ...prevState.configData,
      quantityOfBess:2,
      max_power:Number(prevState.configData?.quantityOfBess )* Number(prevState.configData?.perUnitMaxPower),
      capacity:Number(prevState.configData?.quantityOfBess) * Number(prevState.configData?.perUnitMaxEnergy),
     }
    }
   });
   }
    CBAssetListDispatch({
      type: ACTIONS.BESS_CONTROLLER,
      payload: {
        index: index,
        isChecked:checked,
      },
    });
   
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
  };

  const handleLoadPmAssetRequired = (index) => {
    CBLoadListDispatch({
      type: ACTIONS.LOAD_PM_ASSET_REQUIRED,
      payload:{
        index: index,
        defaultPmData: defaultPmData,
        defaultValues: defaultPreFillData[0],
      }
    })
  }

  const handleEmAssetRequired = (index) => {
    CBAssetListDispatch({
      type: ACTIONS.PV_ASSET_EM_REQUIRED,
      payload: {
        index: index,
        defaultPmData: defaultPmData,
        defaultValues: defaultPreFillData[0],
        projectTypeValue
      },
    });
  };
  const handleRemoteMain = ()=>{
    setRemoteMain(prev => !prev);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    const runCalculateCoordinatesNew = { componentPush: false };
    setRunCalculateCoordinates(runCalculateCoordinatesNew);
    sessionStorage.setItem("componentDataModified",true);
  }
  //* LOCAL STORAGE
  // JSX starts here

  return {
    handleSwitchboardTypeChangeGSX,
    handleSetLoadSide,
    onAddPvExisiting,
    onAddBatteryExisting,
    removeExistingPm,
    handleEnergyReserve,
    handleCbAssetRequired,
    handleLoadCBAssetRequired,
    handleEVCbChange,
    handlePmAssetRequired,
    handleBessController,
    handleLoadPmAssetRequired,
    handleEmAssetRequired,
    handleRemoteMain,
  };
};

export default useAssetSwitchboardHandler;